import { render, staticRenderFns } from "./viewPermisos.vue?vue&type=template&id=3ec01526&"
import script from "./viewPermisos.vue?vue&type=script&lang=js&"
export * from "./viewPermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports